import { FetchImage } from 'components';

import { snapStore } from '../../store';

export const ReceiptImg = () => {
  const imgURL = snapStore((state) => state.imgURL);

  const isIncludesPDF = imgURL?.includes('.pdf');

  if (isIncludesPDF) {
    return (
      <div className='h-full flex flex-col items-center justify-center'>
        <a
          href={imgURL}
          target='_blank'
          rel='noreferrer'
        >
          Link to PDF File
        </a>
      </div>
    );
  }

  return (
    <FetchImage
      alt='Receipt'
      src={imgURL}
      preview={false}
    />
  );
};
